module.exports = __webpack_public_path__ + "static/media/cert6.642d4dd7.png";